import { render, staticRenderFns } from "./TabStaffDrive.vue?vue&type=template&id=6d6bf3e0"
import script from "./TabStaffDrive.vue?vue&type=script&lang=js"
export * from "./TabStaffDrive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports